import { useParams } from "react-router-dom";
import useProductList from "./features/useProductList";
import useCategories from "./features/useCategories";
import useFilter from "./features/useFilter/useFilter";

//#region Type
type ShopViewModel = ReturnType<typeof useFilter> &
  ReturnType<typeof useProductList> &
  ReturnType<typeof useCategories>;
//#endregion

const useShopPage = () => {
  const { categorySlug, subCategorySlug } = useParams();
  const currentCategorySlug = subCategorySlug || categorySlug || undefined;

  const {
    filter,

    selectedSortOption,
    updateSelectedSortOption,

    roastAttrTerms,
    selectedRoastTerm,
    isLoadingRoastAttr,
    updateSelectedRoastAttrTerm,
  } = useFilter({
    currentCategorySlug,
  });

  const { products, hasMoreProducts, isLoadingProducts, fetchMoreProducts } = useProductList({
    filter,
  });

  const { categories, currentCategory, isLoadingCategories, checkIsActiveCategory } = useCategories(
    {
      currentCategorySlug,
    },
  );

  return {
    products,
    hasMoreProducts,
    isLoadingProducts,
    fetchMoreProducts,

    categories,
    currentCategory,
    isLoadingCategories,
    checkIsActiveCategory,

    selectedSortOption,
    updateSelectedSortOption,

    roastAttrTerms,
    selectedRoastTerm,
    isLoadingRoastAttr,
    updateSelectedRoastAttrTerm,
  } as ShopViewModel;
};

export default useShopPage;
